import { localStorage } from 'src/lib/localStorage';
const key = 'integration_jira_feature_flags';

const PROD = {
  accountBaseUrlTemplate: 'https://{domain}.pagerduty.com',
  appBaseUrl: 'https://app.pagerduty.com',
  apiBaseUrl: 'https://api.pagerduty.com',
  curityLogin: true,
  curityRegion: 'UnitedStates',
  isSilentOauthSupported: true,
  oauthClientId: 'b4b6b15314f81e32c1ef198e9fb776228981eb7bed3d918fdcb00eca3ec3be60',
  silentOauthClientId: '9fe69c8aa65804f124dd4db714be417a3e0d12d66027665fcb2344487234f48b',
  integrationServiceBaseUrl: 'https://app.pagerduty.com/integration-jira-service',
  identityBaseUrl: 'https://identity.pagerduty.com',
  useGenericWebhooks: false,
  logsMaxConnectionAttempts: 20,
  logsNumberOfExpectedAllocations: 5,
  segmentKey: 'hNXKcLjFLMfsoD6SRPZUp1rGGEPxfup9',
  jiraServerV3AddonId: 'P41IQWW',
  genericOutboundIntegrationId: 'PJFWPEP',
  jiraServerV4OutboundIntegrationId: 'PLFJ84C',
};

const EUPROD = {
  accountBaseUrlTemplate: 'https://{domain}.eu.pagerduty.com',
  appBaseUrl: 'https://app.eu.pagerduty.com',
  apiBaseUrl: 'https://api.eu.pagerduty.com',
  curityLogin: true,
  curityRegion: 'Europe',
  isSilentOauthSupported: true,
  oauthClientId: 'b4b6b15314f81e32c1ef198e9fb776228981eb7bed3d918fdcb00eca3ec3be60',
  silentOauthClientId: '9fe69c8aa65804f124dd4db714be417a3e0d12d66027665fcb2344487234f48b',
  integrationServiceBaseUrl: 'https://app.eu.pagerduty.com/integration-jira-service',
  identityBaseUrl: 'https://identity.pagerduty.com',
  useGenericWebhooks: false,
  logsMaxConnectionAttempts: 12,
  logsNumberOfExpectedAllocations: 4,
  segmentKey: '5ik0nnO7zmAeFDRFlvWbkjY6XY9511qS',
  jiraServerV3AddonId: 'P41IQWW',
  genericOutboundIntegrationId: 'PJFWPEP',
  jiraServerV4OutboundIntegrationId: 'PLFJ84C',
};

const STAGE = {
  accountBaseUrlTemplate: 'https://{domain}.pd-staging.com',
  appBaseUrl: 'https://app.pd-staging.com',
  apiBaseUrl: 'https://api.pd-staging.com',
  curityLogin: true,
  curityRegion: 'UnitedStates',
  isSilentOauthSupported: true,
  oauthClientId: 'b4b6b15314f81e32c1ef198e9fb776228981eb7bed3d918fdcb00eca3ec3be60',
  silentOauthClientId: '9fe69c8aa65804f124dd4db714be417a3e0d12d66027665fcb2344487234f48b',
  integrationServiceBaseUrl: 'https://app.pd-staging.com/integration-jira-service',
  identityBaseUrl: 'https://identity.pd-staging.com',
  useGenericWebhooks: false,
  logsMaxConnectionAttempts: 8,
  logsNumberOfExpectedAllocations: 2,
  segmentKey: 'KBh2aFu15jvLzogAfsERYo3TuHWh2aRm',
  jiraServerV3AddonId: 'PRJFSAZ',
  genericOutboundIntegrationId: 'PJFWPEP',
  jiraServerV4OutboundIntegrationId: 'P8F8K54',
};

let features;
let CURRENT_ENV;
let currentProdEnv;

// it is potentially possible to calculate features and CURRENT_ENV as soon as this code loads,
// but it requires localStorage access, which may be blocked by some browsers
// let other code deal with that, and only access localStorage when features where requested
function initWithCache() {
  if (features) return;

  features = ({
    loginToStaging: false,
    loginToEu: false,
    jiraServiceLocationBaseUrl: '',
    uiBranch: '',
    uiSha: '',
    ...localStorage.getItem(key) || {}
  });

  currentProdEnv = window.location.origin === 'https://app.eu.pagerduty.com' ? EUPROD : PROD;

  let env = currentProdEnv;
  if (features.loginToEu) env = EUPROD;
  if (features.loginToStaging) env = STAGE;

  CURRENT_ENV = {
    ...env,
    integrationServiceBaseUrl: currentProdEnv.integrationServiceBaseUrl
  };

  if (features.jiraServiceLocationBaseUrl) {
    CURRENT_ENV.integrationServiceBaseUrl = `${features.jiraServiceLocationBaseUrl}/integration-jira-service`;
    CURRENT_ENV.useGenericWebhooks = true;
    if (CURRENT_ENV.integrationServiceBaseUrl === PROD.integrationServiceBaseUrl) CURRENT_ENV.useGenericWebhooks = PROD.useGenericWebhooks;
    if (CURRENT_ENV.integrationServiceBaseUrl === EUPROD.integrationServiceBaseUrl) CURRENT_ENV.useGenericWebhooks = EUPROD.useGenericWebhooks;
    if (CURRENT_ENV.integrationServiceBaseUrl === STAGE.integrationServiceBaseUrl) CURRENT_ENV.useGenericWebhooks = STAGE.useGenericWebhooks;
  }

  if (![PROD.integrationServiceBaseUrl, STAGE.integrationServiceBaseUrl, EUPROD.integrationServiceBaseUrl].includes(CURRENT_ENV.integrationServiceBaseUrl)) {
    CURRENT_ENV.logsMaxConnectionAttempts = 1;
    CURRENT_ENV.logsNumberOfExpectedAllocations = 1;
  }
}

export const getFeatures = () => {
  initWithCache();
  return features;
};

export const getEnvironment = () => {
  initWithCache();
  return CURRENT_ENV;
};

export const getProdEnvironment = () => {
  initWithCache();
  return currentProdEnv;
};

export const setFeatures = ({ ...features }) => {
  localStorage.setItem(key, {
    ...localStorage.getItem(key),
    ...features
  });
};

export const PD_ICON = 'https://pd-static-assets.pagerduty.com/favicons/apple-touch-icon-precomposed.png';
export const JIRA_ICON = 'https://pagerduty.atlassian.net/s/-40wwlj/b/20/1115c169fbd17501412444571f470d1b/_/favicon-software.ico';
